import React from "react";
import { useSelector } from "react-redux";
import MyPromoCodeCard from "../../componet/my-promo-code-card";

const ReferralCodePage: React.FC = () => {
  // Adjust selector path if your user state is different
  const userId = useSelector((state: any) => state.user.userData.id);

  return (
    <div className="max-w-xl p-6 mx-auto">
      <h1 className="mb-4 text-2xl font-bold">Code Promo Personnel</h1>
      <MyPromoCodeCard userId={userId} />
    </div>
  );
};

export default ReferralCodePage;
